import { render, staticRenderFns } from "./LiveIcon.vue?vue&type=template&id=6ff2e8a9&scoped=true"
var script = {}
import style0 from "./LiveIcon.vue?vue&type=style&index=0&id=6ff2e8a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2e8a9",
  null
  
)

export default component.exports